import { render } from "./MarketView.vue?vue&type=template&id=60131fae"
import script from "./MarketView.vue?vue&type=script&lang=js"
export * from "./MarketView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__